import styled from "styled-components";
import { Color, getColor } from "../../../theme/color";
import { getMarginAsPixels, getMediaQuery, getUnitAsPixels, ScreenSize } from "../../../theme/layout";
import { getTypography, Type } from "../../../theme/typography";

export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: ${getMarginAsPixels(ScreenSize.SMALL)};
  padding-right: ${getMarginAsPixels(ScreenSize.SMALL)};
  padding-top: ${getUnitAsPixels({ multiplier: 3 })};
  padding-bottom: ${getUnitAsPixels({ multiplier: 3 })};
  background-color: ${getColor(Color.LIGHT_GREY)};

  ${getMediaQuery(ScreenSize.MEDIUM)}{
    padding-left: ${getMarginAsPixels(ScreenSize.MEDIUM)};
    padding-right: ${getMarginAsPixels(ScreenSize.MEDIUM)};
  }

  ${getMediaQuery(ScreenSize.LARGE)}{
    padding-left: ${getMarginAsPixels(ScreenSize.LARGE)};
    padding-right: ${getMarginAsPixels(ScreenSize.LARGE)};
  }

  ${getMediaQuery(ScreenSize.XLARGE)}{
    padding-left: ${getMarginAsPixels(ScreenSize.XLARGE)};
    padding-right: ${getMarginAsPixels(ScreenSize.XLARGE)};
  }

  ${getMediaQuery(ScreenSize.MAX)}{
    padding-left: ${getMarginAsPixels(ScreenSize.MAX)};
    padding-right: ${getMarginAsPixels(ScreenSize.MAX)};
  }
`;

export const Heading = styled.p`
  ${getTypography(Type.FORM_BUTTON)}
  color: ${getColor(Color.DARK_BLUE)};
`;